import {
	animation,
	trigger,
	animate,
	transition,
	state,
	style,
	query,
	group,
	sequence,
	animateChild,
	stagger
} from '@angular/animations';

export const navigationAnimation = trigger('navigationAnimation', [
	state('up', style({ pointerEvents: 'none', opacity: 0, transform: 'translate3d(0em, -4em, 0em)'})),
	state('down', style({ pointerEvents: 'all', opacity: 1, transform: 'translate3d(0em, 0em, 0em)'})),


	transition('down => up', [
		 style({ pointerEvents: 'none' }),
    animate('250ms 0s ease-in', style({ pointerEvents: 'none', opacity: 0, transform: 'translate3d(0em, -4em, 0em)' })),
  ]),

  transition('up => down', [
    animate('250ms 0s ease-out', style({ opacity: 1, transform: 'translate3d(0em, 0em, 0em)' })),
    style({ pointerEvents: 'all' })
  ]),

]);

export const mobileBtnAnimation = trigger('mobileBtnAnimation', [
	state('show', style({ opacity: 1, width: '*'})),
	state('hide', style({ opacity: 0, width: '0px'})),


	transition('hide => show', [
    	animate('250ms 0s ease-in-out', style({ opacity: 1, width: '*' })),
    	//animate('50ms 0s ease-in', style({ opacity: 1 })),
  ]),

  transition('show => hide', [
    	animate('250ms 0s ease-in-out', style({ opacity: 0, width: '0px' })),
    	//animate('200ms 0s ease-in-out', style({ width: '0em' })),
  ]),

]);

export const mainRoutesAnimation = trigger('mainRoutesAnimation', [
	state('closed', style({ opacity: 1, transform: 'translate3d(0%, -100%, 0em)' })),
	state('open', style({ opacity: 1, transform: 'translate3d(0%, 0%, 0em)' })),


	transition('* => open', [
		group([
    	animate('250ms 0s cubic-bezier(.07,.74,.62,1.32)', style({ opacity: 1, transform: 'translate3d(0%, 0%, 0em)' })),
			query('.main-route', [
					style({ opacity: 0 }),
          animate('100ms 250ms ease-out', style({ opacity: 1 }))
      ],
      	{ optional: true }
      ) 
		])
	]),

  transition('* => closed', [
  	group([
    	animate('250ms 100ms ease-in', style({ opacity: 1, transform: 'translate3d(0%, -100%, 0em)' })),
    	query('.main-route', [
					style({ opacity: 1 }),
          animate('100ms 100ms ease-in', style({ opacity: 0 })),
          style({ opacity: 0 })
      ],
      	{ optional: true }
      )
  	])
    	
  ]),

]);


export const mainRouteAnimation = trigger('mainRouteAnimation', [
	state('closed', style({ opacity: 0 })),
	state('open', style({ opacity: 1 })),

	transition('* => open', [
		style({ opacity: 0 }),
		animate('1000ms 0ms ease-in', style({ opacity: 1 }))
	]),

  transition('* => closed', [
    	animate('250ms 0ms ease-in', style({ opacity: 0 })),
  ]),

]);
